import { render, staticRenderFns } from "./OpenTextQuestion.vue?vue&type=template&id=7a74c248&scoped=true&"
import script from "./OpenTextQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenTextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OpenTextQuestion.vue?vue&type=style&index=0&id=7a74c248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a74c248",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
